import _ from "lodash";
import { config } from "../constants/config";

function usedTerms({ ageGroup, category }) {
	const ageGroupParam = ageGroup ? `age-groups=` + ageGroup : "";

	const categoryParam = category ? `pr-category=` + category : "";

	// return (
	// 	// TODO: change back later
	// 	// config.CUSTOM_API_DOMAIN +
	// 	`http://eca2.itp17.com/wp-json/eca/v1/hide-terms?${ageGroupParam}${
	// 		category ? "&" + categoryParam : categoryParam
	// 	}`
	// );
	// console.log("endpoint to delete": config.CUSTOM_API_DOMAIN + (config.CUSTOM_API_DOMAIN.endsWith("/")
	// ? ""
	// : "/") +
	// 		`v1/hide-terms?${ageGroupParam}${
	// 			category ? "&" + categoryParam : categoryParam
	// 		}`);
	return (
		// TODO: change back later
		// config.CUSTOM_API_DOMAIN +
		// `http://eca2.itp17.com/wp-json/eca/v1/hide-terms?${ageGroupParam}${
		// config.CUSTOM_API_DOMAIN + (config.CUSTOM_API_DOMAIN.endsWith("/")
		// 	? ""
		// 	: "/") +
					`v1/hide-terms?${ageGroupParam}${
						category ? "&" + categoryParam : categoryParam
					}`
	);
}

function getPosts({ lang, page, ageGroup, category, contentType, tags = [] }) {
	// const per_pageParam = page
	// 	? `per_page=${config.ITEMS_PER_PAGE * page}`
	// 	: `per_page=${config.ITEMS_PER_PAGE}`;
	const per_pageParam = `per_page=${config.ITEMS_PER_PAGE}`;
	const pageParam = page ? `&page=${page}`:`&page=1`;
	
	const ageGroupParam = ageGroup ? `&age-groups=${ageGroup}` : "";

	const categoryParam = category ? `&pr-category=${category}` : "";

	const contentTypeParam = contentType ? `&pr-type=${contentType}` : "";

	// console.log("contentTypeParam", contentTypeParam);

	const tagsParam = tags.length
		? _.map(tags, (tag) => tag ? `&pr-tags[]=` + tag : '').join("")
		: "";

	const langParam = lang ? `&lang=` + lang.toUpperCase() : `&lang=EN`;


	return `${
		config.API_DOMAIN + (config.API_DOMAIN.endsWith("/") ? "" : "/")
	}v2/explore-resources?${per_pageParam}${pageParam}${ageGroupParam}${categoryParam}${contentTypeParam}${tagsParam}${langParam}`;
}

function searchField(params) {

	// console.log()
	return `${
		config.API_DOMAIN + (config.API_DOMAIN.endsWith("/") ? "" : "/")
	}v2/search?subtype=explore-resources&per_page=${
		config.ITEMS_PER_PAGE * params.page
	}&search=${params.search}&lang=${params.lang?.toUpperCase()}`;
}

export const endpoints = {
	searchField,
	getPosts,
	usedTerms,
	ageGroups: `/v2/age-groups`,
	categories: `/v2/pr-category`,
	prTypes: "/v2/pr-type",
	tags: `/v2/pr-tags`,
	nextPage: (currentUrl, page) =>
		`${currentUrl}&offset=${config.ITEMS_PER_PAGE * page}`,
};
